__webpack_require__.p = "https://static.gamiphy.co/sdk/loyalty-station/desktop/";